import styled, { CSSProperties } from 'styled-components';
import { ChangeEvent, FocusEvent, MouseEvent, useRef, useState } from 'react';

const InputContainer = styled.div`
	width: 100%;
	position: relative;
`;

const StyledInput = styled.input`
	width: 100%;
	height: auto;
	padding: 0.65rem 1.5rem;

	border: 1px solid ${({ theme }) => theme.input_border};
	background: ${({ theme }) => theme.input_bg};
	outline: none;

	font-family: ${({ theme }) => theme.FONTS_PRIMARY};
	color: ${({ theme }) => theme.input_fg};
	font-size: 1.2rem;
	font-weight: 400;

	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	border-radius: 4px;

	&:disabled {
		cursor: not-allowed;
		opacity: 0.4;
	}
	&::placeholder {
		color: ${({ theme }) => theme.input_placeholder};
	}
	&:focus {
		border-color: ${({ theme }) => theme.input_border_active};
	}
`;

interface InputProps {
	value: string;
	onChange: (value: string, e?: ChangeEvent<HTMLInputElement>) => void;
	id?: string;
	type?: string;
	placeholder?: string;
	style?: CSSProperties;
	styleInput?: CSSProperties;
	className?: string;
	disabled?: boolean;
	onFocus?: (e?: FocusEvent<HTMLInputElement>) => void;
	onBlur?: (e?: FocusEvent<HTMLInputElement>) => void;
	onChangeMap?: (value: string) => string | undefined;
	onBlurMap?: (value: string) => string | undefined;
	readOnly?: boolean;
}

export function Input(props: InputProps) {
	const {
		id,
		type,
		placeholder,
		style,
		styleInput,
		value,
		className,
		disabled,
		onFocus,
		onBlur,
		onChange,
		onChangeMap,
		onBlurMap,
		readOnly,
	} = props;

	const focusValueCache = useRef<string>(value);

	const [_localValue, setLocalValue] = useState<string>(value);

	const onInputFocus = (e: FocusEvent<HTMLInputElement>) => {
		focusValueCache.current = value;
		setLocalValue(value);
		onFocus?.(e);
	};

	const onInputBlur = (e: FocusEvent<HTMLInputElement>) => {
		const mappedValue = onBlurMap ? onBlurMap(e.target.value) : e.target.value;
		if (mappedValue === undefined) {
			onChange?.(focusValueCache.current);
		} else {
			onChange?.(mappedValue, e);
		}
		onBlur?.(e);
	};

	const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
		const mappedValue = onChangeMap ? onChangeMap(e.target.value) : e.target.value;
		if (mappedValue === undefined) return;
		setLocalValue(mappedValue);
	};

	const onRightClickTask = (e: MouseEvent) => {
		if (e) e.stopPropagation();
	};

	return (
		<InputContainer id={id && id} style={style && style} className={className && className}>
			<StyledInput
				disabled={disabled}
				onFocus={onInputFocus}
				onBlur={onInputBlur}
				onChange={onInputChange}
				value={_localValue}
				type={type}
				placeholder={placeholder}
				style={styleInput && styleInput}
				onContextMenu={onRightClickTask}
				readOnly={readOnly}
			/>
		</InputContainer>
	);
}
